// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"overlay_wrapper__2gxIy","overlay":"overlay_overlay__3cKU1","tail":"overlay_tail__2ta4x"};